/**
 * @file 混入 - 页面核心
 * @author hardylin <hardylin@tencent.com>
 */
import { jsonp } from 'scripts/request'
import { dynamicApi } from "../api/dynamicApi.js"

export default {
    data() {
        return {
            mReported: true // 是否在 created 中已上报过，防止重复上报
        }
    },

    created() {
        this.mPageView()
        this.getMessageNum()
        this.saveFirstRouter()
    },

    activated() {
        if (this.mReported) {
            this.mReported = false
            return
        }
        this.mPageView()
        this.getMessageNum()
    },

    methods: {
        mPageView() {

            // #region Mosso PV 上报
            window.setSite = {
                siteType: 'os',
                pageType: this.$route.name,
                pageName: this.$route.meta.name,
                project: 'base',
                osact: 'ingame',
            }
            if (typeof pgvMain == 'function') {
                pgvMain({
                    repeatApplay: 'true',
                    virtualDomain: `${ this.$store.state.global.game == 'srpg' ? 'war' : this.$store.state.global.game }.qq.com`,
                    virtualURL: `/ingame${ this.$route.path }`
                })
            }
            // #endregion

        },

        /**
         * 获取消息数量
         */
        getMessageNum() {
            jsonp({
                url: '/messagecenter/query_not_read_nums.php',
                data: {
                    msg_type: '1050001|1070002'
                }
            }).then(result => {
                dynamicApi.getSysMsgList({  //拉取精准消息系统的接口
                    last_read_id: 0, 
                    limit: 6, 
                    page: 1,
                    isReaded: 0
                }).then(data => {
                    if(data.msg_feed_list && data.msg_feed_list.length > 0){
                        this.$store.commit('me/updateMessageNum', data.msg_feed_list[0].id - data.max_read_id + result.num)  //精准消息的数量 加上原本的消息数量
                    }
                }).catch(msg => {
                    this.$store.commit('me/updateMessageNum', result.num)
                })
            })
        },

        saveFirstRouter() {
            if (sessionStorage.igFirstRoute) {
                return
            }
            sessionStorage.igFirstRoute = this.$route.path
        },
    }
}